// extracted by mini-css-extract-plugin
export default {"back-wrapper":"EnterpriseEditor_back-wrapper__VHAuc","box":"EnterpriseEditor_box__BizNi","section":"EnterpriseEditor_section__kjSkt"};